module.exports = __webpack_public_path__ + "img/warning.3d175c42.svg";